<template>
  <div
    class="progress-container"
    :class="{
      'progress-container-full-screen': isFullScreen,
      'progress-container-bubble-inline': isBubble && !isFullScreen,
      'progress-container-embed-mobile': isEmbedMobile,
    }"
  >
    <div class="chapters-container">
      <div
        v-for="(_, index) in chapterCount"
        :key="index"
        class="chapter"
        :style="{
          width: `${chapterWidth}%`,
          marginRight: index === chapterCount - 1 ? '0' : '2px',
        }"
      >
        <div
          class="chapter-fill"
          :style="{
            transform: `scaleX(${getChapterProgress(index)})`,
            transition: immediateUpdate ? 'none' : 'transform 0.3s ease-out',
          }"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      immediateUpdate: false,
      lastTimeUpdate: 0,
    };
  },
  props: {
    currentTime: {
      type: Number,
      default: 0,
    },
    duration: {
      type: Number,
      required: true,
    },
    partitions: {
      type: Array,
      default: () => [],
    },
    isFullScreen: {
      type: Boolean,
      default: false,
    },
    isBubble: {
      type: Boolean,
      default: false,
    },
    isEmbedMobile: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    chapterCount() {
      return this.partitions.length + 1;
    },

    chapterWidth() {
      return (100 / this.chapterCount).toFixed(3);
    },

    chapterTimes() {
      return [
        0,
        ...this.partitions.map((t) =>
          typeof t === "string" ? this.parseTimeString(t) : t
        ),
        this.duration,
      ].sort((a, b) => a - b);
    },
  },
  watch: {
    currentTime: {
      handler() {
        this.$nextTick(() => {
          this.immediateUpdate = false;
        });
      },
      flush: "post",
    },
  },

  methods: {
    getChapterProgress(index) {
      const chapterStart = this.chapterTimes[index];
      const chapterEnd = this.chapterTimes[index + 1];

      if (this.currentTime <= chapterStart) return 0;
      if (this.currentTime >= chapterEnd) return 1;

      return (this.currentTime - chapterStart) / (chapterEnd - chapterStart);
    },
    parseTimeString(timeStr) {
      const parts = timeStr.split(":").reverse();
      return parts.reduce((acc, part, index) => {
        return acc + parseInt(part || 0) * Math.pow(60, index);
      }, 0);
    },
  },

};
</script>

<style scoped lang="scss">
.progress-container {
  position: absolute;
  top: 3px;
  left: 8px;
  right: 8px;
  height: 4px;
  z-index: 1;
  border-radius: 2px;
  background: rgba(0, 0, 0, 0.08);
  &::before {
    content: "";
    position: absolute;
    top: -3px;
    left: -8px;
    right: -8px;
    background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.3) 0%,
      rgba(0, 0, 0, 0.2) 50%,
      rgba(0, 0, 0, 0.1) 100%
    );
    filter: blur(30px);
    height: 60px;
    pointer-events: none;
    z-index: 0;
  }
}
.progress-container-full-screen {
  left: 14px;
  right: 16px;
  &::before {
    left: -14px;
    right: -16px;
  }
}

.progress-container-bubble-inline {
  left: 14px;
  &::before {
    left: -14px;
  }
}
.progress-container-embed-mobile {
  right: 8px;
  &::before {
    right: -8px;
  }
}

.chapters-container {
  display: flex;
  height: 100%;
  width: 100%;
  position: relative;
  border-radius: 2px;
}

.chapter {
  height: 3px;
  background: rgba(255, 255, 255, 0.5);
  position: relative;
  overflow: hidden;
  border-radius: 2px;
  transition: width 0.3s ease;
  will-change: transform;
}

.chapter-fill {
  width: 100%;
  transform-origin: left;
  transition: transform 0.15s linear;
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  background: #fff;
  border-radius: 2px;
  will-change: transform;
  backface-visibility: hidden;
  transform: translateZ(0);
}

.chapter:hover .chapter-fill {
  filter: brightness(1.1);
}
</style>
